import { render, staticRenderFns } from "./SiloDetail.vue?vue&type=template&id=d7fdce78&scoped=true&"
import script from "./SiloDetail.vue?vue&type=script&lang=ts&"
export * from "./SiloDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SiloDetail.vue?vue&type=style&index=0&id=d7fdce78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fdce78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7fdce78')) {
      api.createRecord('d7fdce78', component.options)
    } else {
      api.reload('d7fdce78', component.options)
    }
    module.hot.accept("./SiloDetail.vue?vue&type=template&id=d7fdce78&scoped=true&", function () {
      api.rerender('d7fdce78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SiloDetail.vue"
export default component.exports